// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O9Ti","colBig":"styles_colBig__9Eclx","colSmall":"styles_colSmall__3ZN5M"};